<template>
    <list-group-item :action="clickAction" :color="message.clicked ? null : 'primary'" class="small">
        <div class="x-small text-muted mb-1">
            {{ sent }}
        </div>
        <div v-if="message.content" class="text-wrap-pre-line">
            {{ message.content.replace(/(?:https?|ftp):\/\/[\n\S]+/g, '') }}
        </div>
        <div v-else-if="message.subject" class="text-wrap-pre-line">
            {{ message.subject }}
        </div>
        <div v-if="relatedLabels && relatedLabels.length" class="mt-2">
            <badge v-for="(related, index) in relatedLabels" :key="`message-${message.id}-related-lbl-${index}`" class="me-1 text-wrap">
                {{ related.label }} <template v-if="related.propertyName">at {{ related.propertyName }}</template>
            </badge>
        </div>
        <modal v-if="showExternalNotificationUrl != null" size="xl" @close="closeExternalNotification" :open="externalNotificationOpen">
            <template #header>External View</template>
            <template #default>
                <iframe :src="showExternalNotificationUrl" class="d-block vh-70 w-100"></iframe>
            </template>
            <template #buttons>
                <ui-button color="secondary" @click="externalNotificationOpen=false" :underline="true" block="sm">
                    Close
                </ui-button>
            </template>
        </modal>
    </list-group-item>
</template>

<script type="text/javascript">
    import UIComponents from '@/components/UI/index.vue';
    import ApiObject from '@/classes/ApiObject.js';
    import MenuNotifications from '@/classes/MenuNotifications.js';
    import Modal from '@/components/Action/Modal.vue';

    export default {
        components: {
            Modal,
            ...UIComponents,
        },

        data() {
            return {
                showExternalNotificationUrl: null,
                externalNotificationOpen: true,
            };
        },

        props: {
            message: {
                type: ApiObject,
                required: true,
            },
        },

        emits: ['click', 'showMessage'],

        computed: {
            sent() {
                if (this.message.sentOn) {
                    return this.message.sentOn.format('n/j/Y g:i a');
                }
                else {
                    return 'Now';
                }
            },

            relatedLabels() {
                if (
                    (this.message.commentLinks) && 
                    (this.message.commentLinks.mrAdmin) && 
                    (this.message.commentLinks.mrAdmin.length)
                ) {
                    return this.message.commentLinks.mrAdmin;
                }
                else if (
                    (this.message.commentLinks) && 
                    (this.message.commentLinks.legacy) && 
                    (this.message.commentLinks.legacy.length)
                ) {
                    return this.message.commentLinks.legacy;
                }
                return null;
            },
        },

        methods: {
            closeExternalNotification() {
                this.showExternalNotificationUrl = null;
                this.externalNotificationOpen = true;
            },

            async clickAction() {
                this.$emit('click');
                MenuNotifications.markNotificationClicked(this.message);

                let url = MenuNotifications.alertUrl(this.message);

                if (url) {
                    if (MenuNotifications.hasLocalPath(this.message)) {
                        this.$router.push(MenuNotifications.localPath(this.message));
                    }
                    else {
                        location.href = await MenuNotifications.absolutePath(this.message);
                    }
                }
                else {
                    this.$emit('showMessage', this.message);
                }
            },
        },
    }
</script>